// MMP1 - FH Salzburg - MultiMediaTechnology
// Tobias Franek <tfranek.mmt-b2018@fh-salzburg.ac.at>

import React, { Component } from 'react';
import { observer } from 'mobx-react';
import Button from '../../Util/Button/Button';
import './DeleteAllComments.scss';

@observer class DeleteAllComments extends Component<any, any> {

	
	render() {
		return (
			<div className="delete-all-comments-dialog">
                <p>If you change your mind, all your comments will be deleted!</p>
                <Button text="continue" onClick={this.props.action} loading={this.props.loading}/>
            </div>
		)
	}
}

export default DeleteAllComments;